import colors from './colors';
const commons = {
  lineHeight: {
    xxSmall: '0.5rem',
    xSmall: '1rem',
    small4: '2rem',
    small: '3rem',
    default: '1rem',
    large: '5rem',
    xLarge: '6rem',
    xxLarge: '7rem',
    big: '8rem',
    xBig: '9rem',
    xxBig: '10rem',
  },
  fontSize: {
    xxSmall: '13px',
    xSmall: '1rem',
    small13: '2rem',
    small: '3rem',
    default: '1rem',
    medium: '5rem',
    large: '6rem',
    xLarge: '7rem',
    xxLarge: '8rem',
    xxxLarge: '9rem',
    big: '10rem',
    xBig: '11rem',
    xxBig: '12rem',
  },
  fontWeight: {
    normal: 'normal',
    italic: 'italic',
    semiBold: '600',
    bold: 'bold',
  },
  fontFamily: 'Raleway, sans-serif',
  shadown: {
    default: {
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.25,
      shadowRadius: 2,
      elevation: 2,
    },
  },
  bottom: typeof window !== 'undefined' && window.innerWidth < 600 ? 20 : 0,
  width: typeof window !== 'undefined' ? window.innerWidth : 0,
  height: typeof window !== 'undefined' ? window.innerHeight : 0,
};

export const color_dict = {
  warning: colors.warning.lightGold,
  default: colors.primary.orange,
  error: colors.error.deepRed,
  success: colors.success.deepGreen,
  secondary: colors.secondary.deepNavy,
};

export default commons;
